import { notification } from 'antd';
import type { NotificationInstance } from 'antd/es/notification/interface';

/** 泡泡类型 */
export declare type antdNotificationType = 'success' | 'error' | 'info' | 'warning' | 'open';

/**
 * 模块级 notification 实例
 * 默认使用静态 notification 作为兜底（会导致 ConfigProvider 上下文丢失），
 * 推荐在根组件通过 setNotificationApi 注入 App.useApp() 的实例。
 */
let notificationApi: NotificationInstance = notification;

/**
 * 注入 notification 实例
 * 在根组件中调用一次，例如：
 *   const { notification } = App.useApp();
 *   useEffect(() => { setNotificationApi(notification); }, [notification]);
 */
export const setNotificationApi = (api: NotificationInstance) => {
    notificationApi = api;
};

/**
* 右侧提示泡泡
* @param type 类型 'success', 'error','info','warning','open'
* @param message 消息
* @param description 描述
*/
const AntdNotification = (type: antdNotificationType, message: string, description?: string) => {
    switch (type) {
        case 'success':
            notificationApi.success({
                message,
                description: JSON.stringify(description),
                duration: 2,
            });
            break;

        case 'error':
            notificationApi.error({
                message,
                description: JSON.stringify(description),
                duration: 2
            });
            break;

        case 'info':
            notificationApi.info({
                message,
                description: JSON.stringify(description),
                duration: 2
            });
            break;

        case 'warning':
            notificationApi.warning({
                message,
                description: JSON.stringify(description),
                duration: 2,
            });
            break;

        case 'open':
            notificationApi.open({
                message,
                description: JSON.stringify(description),
                duration: 2
            });
            break;
    }
}

export default AntdNotification;